import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  background-color: #04031d;
  color: #fff;
`;
export const Container = styled.div``;
export const Row = styled.div`
    display: grid;
    grid-column-gap: 5em;
    grid-template-columns: repeat(auto-fit, minmax(20em, 1fr));
    padding: 5%;
    grid-row-gap: 2em;
    grid-auto-rows: max-content;

  @media (min-width: 200px) and (max-width: 719px){
    padding: 5%;
  }
`;
export const Col = styled.div`
  padding-bottom: 1.5em;

  @media (min-width: 200px) and (max-width: 699px) {
    &:nth-child(1) {
      grid-row: 3/4;
    }
  }
`;
export const Contact = styled.div``;
export const Div = styled.div`
  display: flex;
  margin-bottom: 1.5em;

  p {
    font-size: 1.2em;
    padding-left: 1em;
  }
`;
export const Links = styled.div`
  h1 {
    padding-bottom: 1em;
    margin: 0;
  }
`;
export const Ul = styled.ul`
  list-style: none;
`;
export const Li = styled.li`
  padding: 1em 0em;
`;
export const Subscribe = styled.div``;
export const Form = styled.form`
  .btn {
    background: rgb(259, 91, 65);
    color: #eee;
    padding: 1em;
    margin-top: 1em;
    border-radius: 30px;
  }
`;
export const InputGroup = styled.div`
  width: 100%;
`;
export const Input = styled.input`
  width: 100%;
  max-width: 20em;
  padding: 1em;
  margin: 0.5em 0;
  outline: none;
  border-radius: 5px;
  border: 1px solid #999;
`;
